import { changeEnvUrl, getAppEnv, removeStorage } from '@common/assets/ts/utils';
import { apiMap } from '@common/assets/ts/const';
import { useStoreCommon } from '@common/store/common';
import Vue from 'vue';
import { openLogin, openWebview, jsbSupportMap } from '@q-front-npm/jsbridge';
import { useStore } from '@/store';
import { FreereaderRequest, IOptionsConfig, IRetryConfig } from '@q-front-npm/request';
const isDev = import.meta.env.VITE_ENV === 'dev';
const isProd = import.meta.env.VITE_ENV === 'production';
const isTest = import.meta.env.VITE_ENV === 'test';
const retryingUrl: string[] = [];
// 当前debug包所处环境
const testEnv = getAppEnv();
const requestConfig: IOptionsConfig = {
    isDev,
    apiMap,
    toastFn: (msg: string) => {
        Vue.prototype.$toast(msg);
    },
    withCredentials: true,
    useJsb: isDev ? false : true,
    isCrypt: false,
    timeout: 15000,
    retryCount: 3,
    requestInterceptors: async(config: Record<string, any>) => {
        const storeCommon = useStoreCommon();
        if (isDev || isTest) {
            config.params = { ...config.params, test_uid: storeCommon.urlParams.uid, };
        }
        // 只有在debug包中客户端才会加入test-env头部字段test-env
        if (testEnv && !isProd) {
            // 添加header头标识哪个环境
            config.headers = {
                ...config.headers,
                'test-env': testEnv,
            };
            const reg = /^http[\s\S]+/;
            // 无域名请求（直接以当前域名为baseURL请求）
            if (reg.test(config.url || '') || reg.test(config.baseURL || '')) {
                config.baseURL = changeEnvUrl(config.baseURL || '');
                config.url = changeEnvUrl(config.url || '');
            }
        }
        const { appVersion, platform, } = storeCommon.systemInfo;
        // config.headers = { ...config.headers, 'app-version': `${appVersion}`, platform, };
        return config;
    },
    responseInterceptors: (res: Record<string, any>) => {
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        storeCommon.setServerTime(new Date(res?.headers?.date || new Date()).getTime());
        const { errors, } = res.data;
        // 没有token 并且是低版本， 跳转页面，在重定向回来
        if (errors?.code === '44010109') {
            if (!jsbSupportMap.app.header) {
                openWebview(`${window.location.origin}/app-h5/activity/freereaderCommonLogin?full_screen=3`);
                storeCommon.setRefreshPage(true);
                return Promise.reject({ lowVersionToLogin: true, });
            }
            return Promise.reject(res);
        }
        if (errors) {
            return Promise.reject(errors);
        }
        return res.data;
    },
    requestInterceptorsError: (err: any) => {
        console.log('-- request error', err);
        return Promise.reject(err);
    },
    responseInterceptorsError: (err: any) => {
        console.log('-- response error', err);
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        return Promise.reject(err);
    },
    retrying: (config: IRetryConfig) => {
        const inRetryingUrl = retryingUrl.some((url) => (config?.url || '').indexOf(url) > -1);
        if (inRetryingUrl) {
            console.log('-- retrying', config.retryEnd, config.isSuccess);
            const store = useStore();
            store.retryStatus.isRetrying = !config.isSuccess;
            store.retryStatus.retryEnd = config.isSuccess ? false : config.retryEnd;
        }
    },
};

const request = new FreereaderRequest(requestConfig);

export const get = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.get(url, params, config);
};

export const post = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.post(url, params, config);
};

export const postForm = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.postForm(url, params, config);
};
